import request from '@/utils/request'

export function login(mobile_phone, password) {
  return request({
    url: '/api/v1/user/login',
    method: 'post',
    data: {
      mobile_phone,
      password
    }
  })
}

export function logout() {
  return request({
    url: '/api/v1/user/logout',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js